import { COLLECTIONS } from '@/config/collections';

export type TFn = (key: string, opts?: Record<string, unknown>) => string;

/**
 * Dashboard maps key collections two ways: `content` by table (`product_families`,
 * `job_postings`) and `blocked_drafts` by admin route (`families`, `job-postings`). Pages and
 * product families are NOT generic content collections — they have dedicated routes — so they
 * are special-cased here. Everything else resolves through the collection registry; unknown
 * keys come back as `null` (non-navigable).
 */
function isFamilies(col: string): boolean {
  return col === 'families' || col === 'product_families' || col === 'product-families';
}

export function collectionRoute(col: string): string | null {
  if (col === 'pages') return '/';
  if (isFamilies(col)) return '/families';
  const key = col.replace(/_/g, '-');
  return COLLECTIONS.some((c) => c.key === key) ? `/content/${key}` : null;
}

export function collectionLabel(col: string, t: TFn): string {
  if (col === 'pages') return t('nav.pages');
  if (isFamilies(col)) return t('nav.productFamilies');
  const key = col.replace(/_/g, '-');
  const cfg = COLLECTIONS.find((c) => c.key === key);
  return cfg ? t(cfg.label, { defaultValue: cfg.label }) : col.replace(/_/g, ' ');
}
